import api from "./base-api"

const dsPrefabApiV2 = api.injectEndpoints({
    endpoints: (build) => ({
        getPrefabV2DS: build.query({
            query: (id = "") => `v2/ds/prefabs/${id}`,
            providesTags: (result, error, arg) => {
                return result
                    ? [{type: 'PrefabItemDS', id:result.id}, 'PrefabItemDS']
                    : ['PrefabItemDS']
            }
        }),
        getPrefabStringV2DS: build.query({
            query: (id = "") => `v2/ds/prefabs/${id}/string`,
            providesTags: (result, error, arg) => {
                return result
                    ? [{type: 'PrefabItemDS', id:result.id}, 'PrefabItemDS']
                    : ['PrefabItemDS']
            }
        }),
        getPrefabsListV2DS: build.query({
            query: (id = "") => `v2/ds/prefabs`,
            transformResponse(data) {
                return data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
            },
            providesTags: ['PrefabsDS']
        }),
        getPrefabsInfosV2DS: build.query({
            query: (id = "") => `v2/ds/prefabs/infos`,
            transformResponse(data) {
                return data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
            },
            providesTags: ['PrefabsDS']
        }),
        getPrefabsInfoListV2DS: build.query({
            query: (id = "") => `v2/ds/prefabs/info`,
            transformResponse(data) {
                return data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
            },
            providesTags: ['PrefabsDSInfo']
        }),
        getPrefabsMetaDS: build.query({
            query: (id = "") => `v2/ds/prefabs/metas`,
            providesTags: ['PrefabsMetasDS']
        }),
        getPrefabsMeta: build.query({
            query: (game = "") => `v2/${game}/prefabs/metas`,
            providesTags: ['PrefabsMetasDS']
        }),
        createPrefabV2DS: build.mutation({
            query: (body = {}) => ({
                url: "v2/ds/prefabs",
                method: "POST",
                body: body.data,
                env: body.env
            }),
            invalidatesTags: ['PrefabsDS','PrefabsMetasDS']
        }),
        deletePrefabV2DS: build.mutation({
            query: (id = "") => ({
                url: `v2/ds/prefabs/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ['PrefabsDS','PrefabsDSInfo']

        }),
        updatePrefabV2DS: build.mutation({
            query: (data = {}) => ({
                url: `v2/ds/prefabs/${data.id}`,
                method: "PUT",
                body: data.body
            }),
            invalidatesTags: ['PrefabItemDS','PrefabsDSInfo']

        })
    }),
    overrideExisting: false
})

export const {
    useGetPrefabV2DSQuery,
    useGetPrefabsMetaDSQuery,
    useGetPrefabsMetaQuery,
    useGetPrefabStringV2DSQuery,
    useGetPrefabsListV2DSQuery,
    useGetPrefabsInfoListV2DSQuery,
    useGetPrefabsInfosV2DSQuery,
    useCreatePrefabV2DSMutation,
    useDeletePrefabV2DSMutation,
    useUpdatePrefabV2DSMutation
} = dsPrefabApiV2
